// extracted by mini-css-extract-plugin
export default {"positive":"styles_positive__kaMoz","negative":"styles_negative__8oJYW"};